<button (click)="onClick.emit()" [disabled]="disabled" [type]="type" [ngClass]="buttonStyle ? 'button-' + buttonStyle : ''" class="button rounded-button">
  <ng-content></ng-content>
</button>
